import { ga } from 'js/analytics/adapters'
export const trackTestimonialInteraction = () => {
  ga.track('interacted_with_testimonials')
}
